<span class="light-input">
  <img *ngIf="icon" [src]="'../../../assets/icons/' + icon + '.svg'" />
  <input [type]="type" [(ngModel)]="value" [placeholder]="placeholder" (keyup.enter)="onEnterKey ? onEnterKey() : null" [disabled]="disabled" (input)="change()" />
</span>
<label class="input-label" [ngClass]="value?.length ? 'input-label-visible' : 'input-label-hidden'">{{ placeholder }}</label>
